import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import Notifications from 'notiwind' 

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Notifications)

app.mount('#app')

// On app start, if user is authenticated, warm up stock positions store
import { useMyStore } from './stores/mystore'
const token = localStorage.getItem('auth_token_for_mani') || undefined
if (token) {

  const myStore = useMyStore()
  myStore.setToken(token)
  myStore.loadAll(false)
}
